export default __webpack_public_path__ + "static/media/chim2.e8db00a6.webp";